import { render, staticRenderFns } from "./FlexiParent.vue?vue&type=template&id=477a82a7&scoped=true"
import script from "./FlexiParent.vue?vue&type=script&lang=js"
export * from "./FlexiParent.vue?vue&type=script&lang=js"
import style0 from "./FlexiParent.vue?vue&type=style&index=0&id=477a82a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a82a7",
  null
  
)

export default component.exports